// extracted by mini-css-extract-plugin
export default {"headerBar":"QK-z","pointsSection":"RK-z","goToDashboard":"SK-z"};